const SaveIcon = () => {
    return (
        <i className="fa-solid fa-floppy-disk"></i>
    )
}

export default SaveIcon;